import { useEffect, useState } from "react";
import { inputClass } from "./styles";

const CountrySelect = ({ countries, value, onChange, className }) => {
  const [isOpen, setIsOpen] = useState(false);
  const [search, setSearch] = useState("");

  const selectedCountry = countries.find((c) => c.isoCode === value);

  useEffect(() => {
    if (selectedCountry && !isOpen) {
      setSearch(selectedCountry.name);
    } else if (!selectedCountry && !isOpen) {
      setSearch("");
    }
  }, [selectedCountry, isOpen]);

  const filteredCountries = countries.filter((c) =>
    c.name.toLowerCase().includes(search.toLowerCase())
  );

  const handleSelect = (code) => {
    onChange(code);
    setIsOpen(false);
  };

  return (
    <div className="relative">
      <input
        type="text"
        className={`${className || inputClass} relative z-20`}
        value={search}
        onChange={(e) => {
          setSearch(e.target.value);
          if (!isOpen) setIsOpen(true);
        }}
        onFocus={() => {
          setIsOpen(true);
          setSearch("");
        }}
        placeholder="Search country..."
      />
      {isOpen && (
        <>
          <div
            className="fixed inset-0 z-10"
            onClick={() => {
              setIsOpen(false);
              if (selectedCountry) setSearch(selectedCountry.name);
              else setSearch("");
            }}
          />
          <div className="absolute z-20 w-full mt-1 bg-white border border-gray-200 rounded-xl shadow-lg max-h-60 overflow-auto">
            {filteredCountries.length > 0 ? (
              filteredCountries.map((c) => (
                <div
                  key={c.isoCode}
                  className={`px-4 py-2 hover:bg-gray-50 cursor-pointer text-sm ${c.isoCode === value ? "bg-gray-50 font-medium" : ""}`}
                  onClick={() => handleSelect(c.isoCode)}
                >
                  {c.name}
                </div>
              ))
            ) : (
              <div className="px-4 py-2 text-gray-500 text-sm">
                No countries found
              </div>
            )}
          </div>
        </>
      )}
    </div>
  );
};

export default CountrySelect;
